import * as React from "react";
import { IconProps } from "../types";

const Compose2Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M15.25 9.2422V13.25C15.25 14.355 14.355 15.25 13.25 15.25H4.75C3.645 15.25 2.75 14.355 2.75 13.25V4.75C2.75 3.645 3.645 2.75 4.75 2.75H8.75781"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 10.25C7.75 10.25 10.0838 10.1662 10.909 9.34097L15.784 4.46598C16.4053 3.84468 16.4053 2.83727 15.784 2.21597C15.1627 1.59468 14.1553 1.59468 13.534 2.21597L8.659 7.09097C7.8809 7.86907 7.75 10.25 7.75 10.25Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default Compose2Icon;
